module.exports = __webpack_public_path__ + "static/img/5-1.fd6f66ad.png";